
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningRainShowersMonColour as ObiLightningRainShowersMonColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-rain-showers-mon-colour.js';
 
 
 

 
 export const ObiLightningRainShowersMonColour = createComponent({
   react: React,
   tagName: 'obi-lightning-rain-showers-mon-colour',
   elementClass: ObiLightningRainShowersMonColourElement,
   events: {
     
   }
  });
 
 